import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Download, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-10 pb-14 lg:pt-16 lg:pb-20 overflow-hidden bg-brand-cream bg-noise" data-id="element-165">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-166">
        {/* Mobile-only headline above the image */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="lg:hidden text-4xl sm:text-5xl font-serif font-bold text-brand-navy leading-tight mb-8 text-center" data-id="element-167">
          El Método "Fuego Cero":{' '}
          <span className="text-brand-gold" data-id="element-168">
            Desinflama tu abdomen en 7 días
          </span>{' '}
          sin dejar de comer lo que te gusta.
        </motion.h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl order-2 lg:order-1" data-id="element-170">
            {/* Desktop-only headline */}
            <h1 className="hidden lg:block text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-navy leading-tight mb-6" data-id="element-171">
              El Método "Fuego Cero":{' '}
              <span className="text-brand-gold" data-id="element-172">
                Desinflama tu abdomen en 7 días
              </span>{' '}
              sin dejar de comer lo que te gusta.
            </h1>

            <h2 className="text-lg sm:text-xl text-brand-navy/80 font-medium mb-6 leading-relaxed" data-id="element-173">
              La guía definitiva para la mujer chilena de +40 que quiere
              eliminar la hinchazón abdominal, recuperar su energía y volver a
              cerrar ese pantalón — con ingredientes del Líder, Jumbo o la feria
              de tu barrio..
            </h2>

            <div className="space-y-5 mb-8 text-gray-700 leading-relaxed" data-id="element-174">
              {/* Opening line */}
              <p className="text-lg sm:text-xl font-medium text-brand-navy" data-id="element-175">
                Compras lo de siempre.
              </p>

              {/* Product list — visually distinct chips inline */}
              <p className="text-sm sm:text-base italic text-brand-navy/60" data-id="element-176">
                Aceite · pan de molde · yogur · cecinas · jugo en caja.
              </p>

              {/* Supporting context, smaller */}
              <p className="text-sm sm:text-base text-gray-600" data-id="element-177">
                Lo mismo que compraba tu mamá. Lo mismo que hay en cualquier
                cocina chilena.
              </p>

              {/* Emotional anchor — bigger, serif */}
              <p className="text-xl sm:text-2xl font-serif font-semibold text-brand-navy leading-snug pt-2" data-id="element-178">
                Y sin embargo tu abdomen está{' '}
                <span className="text-brand-gold" data-id="element-179">
                  inflamado todos los días.
                </span>
              </p>

              {/* Question — pulled out as quote-style */}
              <p className="text-base sm:text-lg text-brand-navy/85 border-l-2 border-brand-gold/60 pl-4 italic leading-relaxed" data-id="element-180">
                ¿Te ha pasado que te despiertas relativamente bien… pero al
                llegar la tarde sientes que el botón del pantalón va a explotar?
              </p>

              {/* Diagnosis — calm explanatory body */}
              <p className="text-base sm:text-lg" data-id="element-181">
                No es que hayas subido de peso de un día para otro.
              </p>

              <p className="text-base sm:text-lg" data-id="element-182">
                Es que algunos de esos productos que metes al carrito cada
                semana están activamente{' '}
                <span className="font-semibold text-brand-navy" data-id="element-183">
                  irritando tu intestino
                </span>
                , disparando cortisol y creando{' '}
                <span className="font-semibold text-brand-navy" data-id="element-184">
                  inflamación crónica
                </span>
                .
              </p>

              {/* Closer — dramatic, serif, gold */}
              <p className="text-lg sm:text-xl font-serif text-brand-navy leading-snug pt-1" data-id="element-185">
                Y nadie te lo explicó en términos reales.{' '}
                <span className="text-brand-gold italic font-bold" data-id="element-186">
                  Hasta ahora.
                </span>
              </p>
            </div>

            <div className="space-y-4" data-id="element-187">
              <Button className="text-lg w-full sm:w-auto" data-id="element-188">
                ¡SÍ, QUIERO DESINFLAMAR MI ABDOMEN AHORA!
              </Button>

              <div className="flex flex-wrap items-center gap-4 text-sm text-brand-navy/70 mt-4" data-id="element-189">
                <div className="flex items-center gap-1" data-id="element-190">
                  <Download size={16} className="text-brand-green" data-id="element-191" />
                  <span data-id="element-192">Descarga digital instantánea</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-193">
                  <ShieldCheck size={16} className="text-brand-green" data-id="element-194" />
                  <span data-id="element-195">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-196">
                  <Users size={16} className="text-brand-green" data-id="element-197" />
                  <span data-id="element-198">Para mujeres chilenas +40</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-xs sm:max-w-md lg:max-w-full order-1 lg:order-2" data-id="element-199">
            <motion.div animate={{
            y: [-10, 10, -10]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/qnXyCi8Wh4bwVuRp1MBxsU/mockup.png" alt="Portada del eBook Método Fuego Cero Antinflamatorio 15-Min" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-201" />
            </motion.div>
            {/* Decorative background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-gold/10 rounded-full blur-3xl -z-10" data-id="element-202"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}